import { render, staticRenderFns } from "./wxPayInfo.vue?vue&type=template&id=21142c34&scoped=true&"
import script from "./wxPayInfo.vue?vue&type=script&lang=js&"
export * from "./wxPayInfo.vue?vue&type=script&lang=js&"
import style0 from "./wxPayInfo.vue?vue&type=style&index=0&id=21142c34&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21142c34",
  null
  
)

export default component.exports